import { injectable, inject } from 'inversify';
import type { ClinicReportDTO, IReportRepository } from '@/domain/repositories/IReportRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetClinicReportAction {
  constructor(
    @inject(TYPES.IReportRepository) private reportRepository: IReportRepository
  ) {}

  async execute(): Promise<ClinicReportDTO> {
    return this.reportRepository.getClinicReport();
  }
}
